// extracted by mini-css-extract-plugin
export var dividerLine = "_47-0";
export var errorBackground = "_47-1";